import { z } from "zod";

import { AnnouncementType } from "@classview/shared-types";

/**
 * Schema for Organisation, matching the shared Organisation type.
 */
const organisationSchema = z.object({
  value: z.string(),
  label: z.string(),
});

const addAnnouncementSchema = z.object({
  type: z.nativeEnum(AnnouncementType),
  title: z
    .string()
    .min(1, { message: "Title is required" })
    .max(500, { message: "Title must not exceed 500 characters" }),
  message: z
    .string()
    .min(1, { message: "Message is required" })
    .max(2000, { message: "Message must not exceed 2000 characters" }),
  date: z.object({
    from: z.date(),
    to: z.date(),
  }),
  organisations: z.array(organisationSchema).optional(),
});
type AddAnnouncementFormData = z.infer<typeof addAnnouncementSchema>;

export { addAnnouncementSchema };
export type { AddAnnouncementFormData };
